import { GetterTree } from "vuex";
import { IAssetsState } from ".";
import { IRootState } from "@/store/types";
import { IAsset } from "@/models/asset";

export const getters: GetterTree<IAssetsState, IRootState> = {
    assetsList(state): IAsset[] | null {
        return state.assetsList;
    },
    selectedAsset(state): IAsset | null {
        return state.selectedAsset;
    },
    error(state): any {
        return state.error;
    },
};
